<template>
  <Nav></Nav>
  <main class="organization">
    <back-button></back-button>
    <OrganizationEditor :edit="true" :orgSlug="orgSlug"></OrganizationEditor>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import OrganizationEditor from '@/components/OrganizationEditor.vue';

export default defineComponent({
  name: 'Organization',
  components: {
    BackButton,
    Nav,
    OrganizationEditor,
  },
  data() {
    return {
      orgSlug: this.$route.params.org_slug as string,
    };
  },
});
</script>